import initAnalytics from './analytics'
import initLogger from './log'

export default function initTools () {
  initAnalytics()
  initLogger({ identifier: 'uqijku/unusuals' })
}
